import { _adapters } from 'chart.js';
import React from 'react';

function QueueImputs(props) {
  const { changeValues, queue } = props;
  const { name, music, strategy, maxlen, ringinuse, announcePosition, announceFrequency, announceHoldTime, wrapuptime, minAnnounceFrequency, joinempty, leavewhenempty } = queue;
  /*
    IP:
      {
        name: q.namequeue,
        music: q.queuemusiconhold,
        strategy: q.queuestrategy,
        autofill: q.queueautofill,
        maxlen: q.queuemaxlen,
        ringinuse: q.queueringinuse,
        announcePosition: q.queueannounceposition,
        announceFrequency: q.queueannouncefrequency,
        announceHoldTime: q.queueannounceholdtime,
        minAnnounceFrequency: q.queueminannouncefrequency,
        queueEntryVarQueue: q.queuesetqueueentryvarqueue,
        wrapuptime: q.queuewrapuptime,
        joinempty: q.queuejoinempty,
        leavewhenempty: q.queueleavewhenempty
      }
  */

  return (
    <div>
      <div className="columns mx-2">
        <div className="column is-3 field">
          <label className="label">Nome da Fila
            <div className="control">
              <input className="input" name="name" defaultValue={ name } type="text" onChange={(e) => changeValues(e.target)} placeholder="Nome" disabled />
              <p name="name-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label">Música
            <div className="control">
              <div name="music" className="select is-fullwidth">
                <select className="select" name="music" defaultValue={ music } onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="default">Música Padrão</option>
                </select>
              </div>
              <p name="music-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-3 field">
          <label className="label">Estratégia
            <div className="control">
              <div name="strategy" className="select is-fullwidth">
                <select className="select" name="strategy"  defaultValue={ strategy } onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="ringall">Tocar Todos</option>
                  <option value="linear">Linear</option>
                </select>
              </div>
              <p name="strategy-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label">Segunda Chamada
            <div className="control">
              <div name="ringinuse" className="select is-fullwidth">
                <select className="select" name="ringinuse" defaultValue={ ringinuse } onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="yes">Sim</option>
                  <option value="no">Nao</option>
                </select>
              </div>
              <p name="ringinuse-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-1 field">
          <label className="label">Descanso
            <div className="control">
              <input className="input" name="wrapuptime" defaultValue={ wrapuptime } type="number" onChange={(e) => changeValues(e.target)} placeholder="3" />
              <p name="wrapuptime-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
      </div>
      <div className="columns mx-2">
        <div className="column is-2 field">
          <label className="label">Anúncio Posição Fila
            <div className="control">
              <div name="announcePosition" className="select is-fullwidth">
                <select className="select" name="announcePosition" defaultValue={ announcePosition } onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="yes">Sim</option>
                  <option value="no">Nao</option>
                </select>
              </div>
              <p name="announcePosition-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label">Anún. Tempo Estimado
            <div className="control">
              <div name="announceHoldTime" className="select is-fullwidth">
                <select className="select" name="announceHoldTime" defaultValue={ announceHoldTime } onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="yes">Sim</option>
                  <option value="no">Nao</option>
                </select>
              </div>
              <p name="announceHoldTime-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-1 field">
          <label className="label">Mínimo
            <div className="control">
              <input className="input" name="minAnnounceFrequency" defaultValue={ minAnnounceFrequency } type="number" onChange={(e) => changeValues(e.target)} placeholder="35" />
              <p name="minAnnounceFrequency-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-1 field">
          <label className="label">Freq.
            <div className="control">
              <input className="input" name="announceFrequency" defaultValue={ announceFrequency } type="number" onChange={(e) => changeValues(e.target)} placeholder="35" />
              <p name="announceFrequency-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label">Entrar (Se Vazia)
            <div className="control">
              <div name="joinempty" className="select is-fullwidth">
                <select className="select" name="joinempty" defaultValue={ joinempty } onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="yes">Sim</option>
                  <option value="no">Nao</option>
                  <option value="strict">Restrito</option>
                </select>
              </div>
              <p name="joinempty-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label">Sair (Se Vazia)
            <div className="control">
              <div name="leavewhenempty" className="select is-fullwidth">
                <select className="select" name="leavewhenempty" defaultValue={ leavewhenempty } onChange={(e) => changeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="yes">Sim</option>
                  <option value="no">Nao</option>
                  <option value="strict">Restrito</option>
                </select>
              </div>
              <p name="leavewhenempty-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-1 field">
          <label className="label"> Chamadas
            <div className="control">
              <input className="input" name="maxlen" defaultValue={ maxlen } type="number" onChange={(e) => changeValues(e.target)} placeholder="35" />
              <p name="maxlen-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
}

export default QueueImputs;
